// 认证相关 API 服务
import request from '../utils/request';

// 登录请求参数
export interface LoginRequest {
  phone: string;
  password: string;
  captchaId: string;
  captcha: string;
}

// 登录响应
export interface LoginResponse {
  token: string;
  expire: number;
  user: {
    id: number;
    phone: string;
    name?: string;
    role: string;
  };
}

// 验证码响应
export interface CaptchaResponse {
  captchaId: string;
  image: string;
}

/**
 * 获取验证码
 */
export function getCaptcha() {
  return request.get('/captcha');
}

/**
 * 用户登录（新版本 - 使用用户表认证）
 */
export function login(data: LoginRequest) {
  return request.post('/user/login', data);
}

/**
 * 用户登出
 */
export function logout() {
  return request.post('/logout');
}
